if (!customElements.get('collection-showcase')) {
  customElements.define(
    'collection-showcase-products',
    class CollectionsShowcaseProducts extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
        this.boundEventListeners = [];
      }

      connectedCallback() {
        if (this.dataset.enableSlider !== 'true') {
          return;
        }

        this.initSlider();
      }

      init() {
        this.initSlider();
      }

      initSlider() {
        const sliderOptions = {
          slidesPerView: 4,
          spaceBetween: 8,
          breakpoints: {
            768: {
              spaceBetween: 20,
            },
          },
          threshold: 2,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this.querySelector('.swiper'),
          sliderOptions
        );
        this.sliderInstance.init();
      }

      disconnectedCallback() {
        if (this.sliderInstance && typeof this.sliderInstance.slider !== 'undefined') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = null;
        }
      }
    }
  );
}

if (!customElements.get('collection-showcase')) {
  customElements.define(
    'collection-showcase',
    class CollectionsShowcase extends HTMLElement {
      constructor() {
        super();

        this.images = this.querySelectorAll('.collection-showcase__image');
        this.tabItems = this.querySelectorAll('.collection-showcase__tabs li a');
        this.mainContent = this.querySelector('.collection-showcase__contents');
        this.currentIndex = 0;

        this.init();
      }

      init() {
        this.boundTouchChange = this.onTouchChange.bind(this);
        this.boundClick = this.onClick.bind(this);
        this.boundMouseOver = (e) => this.onMouseOver(e);
        this.boundBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const { target } = e;
          const index = Number(target.dataset.index);
          this.setActiveTab(index);
        };

        if (this.tabItems) {
          if ('ontouchstart' in window) {
            this.tabItems.forEach((item) => {
              item.addEventListener('touchstart', this.boundTouchChange, { passive: true });
              item.addEventListener('click', this.boundClick);
            });
          } else {
            this.tabItems.forEach((item) => {
              item.addEventListener('mouseover', this.boundMouseOver);
              item.addEventListener('focus', this.boundMouseOver);
            });
          }
        }

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.boundBlockSelect);
        }
      }

      disconnectedCallback() {
        if (this.tabItems) {
          if ('ontouchstart' in window) {
            this.tabItems.forEach((item) => {
              item.removeEventListener('touchstart', this.boundTouchChange);
              item.removeEventListener('click', this.boundClick);
            });
          } else {
            this.tabItems.forEach((item) => {
              item.removeEventListener('mouseover', this.boundMouseOver);
              item.removeEventListener('focus', this.boundMouseOver);
            });
          }
        }

        if (window.Shopify && window.Shopify.designMode && this.boundBlockSelect) {
          document.removeEventListener('shopify:block:select', this.boundBlockSelect);
        }
      }

      isSelected(tab) {
        return tab.classList.contains('active');
      }

      onMouseOver(e) {
        const { target } = e;
        const index = Number(target.dataset.index);

        if (target.classList.contains('active')) return;

        this.setActiveTab(index);
      }

      onTouchChange(e) {
        const { target } = e;
        const index = Number(target.dataset.index);

        if (this.isSelected(target)) {
          this.preventClick = false;
          return;
        } else {
          this.preventClick = true;
        }

        this.setActiveTab(index);
      }

      onClick(e) {
        if (this.preventClick) {
          e.preventDefault();
        }
      }

      setActiveTab(tabIndex) {
        if (this.currentIndex === tabIndex) {
          return;
        }

        const newImage = this.images[tabIndex];
        if (!newImage) return;
        newImage.hidden = false; // Being load image.
        newImage.classList.add('active');

        const currentImage = this.images[this.currentIndex];
        if (currentImage) currentImage.classList.remove('active');

        const currentItem = this.tabItems[this.currentIndex];
        const newItem = this.tabItems[tabIndex];
        let newTab;

        currentItem.classList.remove('active');
        newItem.classList.add('active');

        const collectionProducts = this.mainContent.querySelectorAll(
          '.collection-showcase__content'
        );
        collectionProducts.forEach((collection) => {
          collection.hidden = true;
          collection.classList.remove('active');
        });

        newTab = this.mainContent.querySelector(
          `.collection-showcase__content[data-index="${tabIndex}"]`
        );
        if (!newTab) {
          const template = this.mainContent.querySelector(`template[data-index="${tabIndex}"]`);
          if (!template) return;
          newTab = document.importNode(template.content, true);
          this.mainContent.appendChild(newTab);
          newTab.hidden = false;
        } else {
          newTab.hidden = false;
        }

        const gridList = newTab.querySelector('grid-list');
        gridList && gridList.showGridItems();

        const motion = newTab.querySelector('motion-element');
        if (motion && (motion.hasAttribute('hold') || !motion._played)) motion.refreshAnimation();

        this.currentIndex = tabIndex;
      }
    }
  );
}
